"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _NavUser = _interopRequireDefault(require("../NavUser/NavUser"));

var _NavApps = _interopRequireDefault(require("../NavApps/NavApps"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 2000,
    display: "flex",
    marginTop: theme.spacing(-8),
    "&[aria-expanded=true]": {
      marginTop: 0
    },
    height: theme.spacing(8),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  button: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

const AppNav = ({
  className,
  expanded = true,
  app,
  user,
  owner,
  onLogin,
  onLogout,
  onSelect
}) => {
  const classes = useStyles();
  return _react.default.createElement("section", {
    className: className || classes.root,
    "aria-expanded": expanded
  }, user && user.uniqueId && _react.default.createElement(_NavApps.default, {
    className: classes.button,
    user: user,
    owners: user && user.owners,
    owner: owner,
    onSelect: onSelect
  }), _react.default.createElement(_NavUser.default, {
    className: classes.button,
    app: app,
    user: user,
    onLogin: onLogin,
    onLogout: onLogout
  }));
};

var _default = AppNav;
exports.default = _default;
module.exports = exports.default;